<template>
  <AuthMain>
    <v-form @keyup.native.enter="validate" @submit.prevent="" ref="form" v-model="valid" lazy-validation> 
      <v-text-field
        prepend-icon="email"
        v-model="email"
        :rules="emailRules"
        label="E-mail"
        required
      ></v-text-field>
      <v-btn
        rounded
        :disabled="!valid"
        color="primary"
        @click="validate"
        type="submit"
        large
        class="elevation"
        >
        Resetar senha
      </v-btn>
      <v-btn
        rounded                  
        :disabled="!valid"
        color="default"
        @click="$router.push('/login')"
        type="submit"
        large
        class="elevation"
        >
        Login
      </v-btn>
    </v-form>
  </AuthMain>
</template>

<script>
  import AuthMain from './AuthMain.vue'
export default {
  name: 'Forgot',
  components: {
    AuthMain
  },
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('forgotPassword', {email: this.email});
      }
    },
  },
  data () {
    return {
      email: '',
      valid: false,
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+/.test(v) || 'E-mail deve ser válido'
      ],
    }
  }
}
</script>

<style lang="css" scoped>
</style>